export const NormalizeUrl = (url: string) => {
    return url.replace(/\/+/g, '/');
};
